// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"129":"e5bf89630758fcce","225":"b3163d42d82db6a4"}[chunkId] + ".js";
};